<template>
  <div class="Polaris-FormLayout__Item">
    


    <div style="--top-bar-background:#00848e; --top-bar-background-lighter:#1d9ba4; --top-bar-color:#f9fafb; --p-frame-offset:0px;">
  <div >
    <div role="combobox" aria-expanded="true" aria-owns="PolarisComboBox14" aria-controls="PolarisComboBox14" aria-haspopup="true" tabindex="0">
      <div>
        <div class="">
          <div class="Polaris-Labelled__LabelWrapper">
            <div class="Polaris-Label"><label id="PolarisTextField14Label" for="PolarisTextField14" class="Polaris-Label__Text" v-text="label"></label></div>
          </div>
          <div class="Polaris-Connected">
            <div class="Polaris-Connected__Item Polaris-Connected__Item--focused Polaris-Connected__Item--primary">
              <div class="Polaris-TextField " :class=" false ? 'Polaris-TextField--focus' : '' " >
                <div class="Polaris-TextField__Prefix" id="PolarisTextField14Prefix"><span class="Polaris-Icon Polaris-Icon--colorInkLighter Polaris-Icon--isColored"><svg viewBox="0 0 20 20" class="Polaris-Icon__Svg" focusable="false" aria-hidden="true">
                      <path d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414" fill-rule="evenodd"></path>
                    </svg></span></div><input id="PolarisTextField14" placeholder="Search" autocomplete="off" class="Polaris-TextField__Input" aria-labelledby="PolarisTextField14Label PolarisTextField14Prefix" aria-invalid="false" aria-autocomplete="list" aria-multiline="false" value="" tabindex="0" aria-controls="Polarispopover14" aria-owns="Polarispopover14" aria-expanded="true">
                <div class="Polaris-TextField__Backdrop"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="Polaris-PositionedOverlay Polaris-Popover__PopoverOverlay Polaris-Popover__PopoverOverlay--open ml-5 w-50" v-show="false" >
  <div class="Polaris-Popover Polaris-Popover--fullWidth" data-polaris-overlay="true">
    <div class="Polaris-Popover__FocusTracker" tabindex="0"></div>
    <div class="Polaris-Popover__Wrapper">
      <div id="Polarispopover14" tabindex="-1" class="Polaris-Popover__Content" style="height: 172px;">
        <div class="Polaris-Popover__Pane Polaris-Scrollable Polaris-Scrollable--vertical Polaris-Scrollable--hasBottomShadow Polaris-Scrollable--verticalHasScrolling" data-polaris-scrollable="true">
          <div id="PolarisComboBox14" role="listbox">
            <ul class="Polaris-OptionList" role="presentation">
              <li>
                <ul class="Polaris-OptionList__Options" id="PolarisOptionList18-0" role="presentation">
                  <li class="Polaris-OptionList-Option" tabindex="-1" role="option"><button id="PolarisComboBox14-0" type="button" class="Polaris-OptionList-Option__SingleSelectOption">Rustic</button></li>
                  <li class="Polaris-OptionList-Option" tabindex="-1" role="option"><button id="PolarisComboBox14-1" type="button" class="Polaris-OptionList-Option__SingleSelectOption">Antique</button></li>
                  <li class="Polaris-OptionList-Option" tabindex="-1" role="option"><button id="PolarisComboBox14-2" type="button" class="Polaris-OptionList-Option__SingleSelectOption">Vinyl</button></li>
                  <li class="Polaris-OptionList-Option" tabindex="-1" role="option"><button id="PolarisComboBox14-3" type="button" class="Polaris-OptionList-Option__SingleSelectOption">Vintage</button></li>
                  <li class="Polaris-OptionList-Option" tabindex="-1" role="option"><button id="PolarisComboBox14-4" type="button" class="Polaris-OptionList-Option__SingleSelectOption">Refurbished</button></li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="Polaris-Popover__FocusTracker" tabindex="0"></div>
  </div>
</div>

  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
      },
      label: {
        type: String,
      },
      helpText: {
        type: String,
      },
      invalid: {
        type: String,
        default: null,
      },
    },
    computed: {
      id() {
        return this._uid;
      }
    }
  }
</script>

<style>

</style>